module.exports = "/_next/static/images/ProcessingValidationTransformation-40256528b5f8ce9436074acbbc8c94f5.webp";